<template>
  <page-header-wrapper>
    <a-spin :spinning="loading">
      <div class="dashboard-overview">
        <!-- 基本数据 -->
        <div class="section-title">基本数据</div>
        <a-row :gutter="16" class="statistics-row">
          <a-col :xs="12" :sm="12" :md="6">
            <div class="stat-card-large stat-card-red">
              <div class="stat-icon">
                <a-icon type="dollar" />
              </div>
              <div class="stat-content">
                <div class="stat-value">{{ formatNumber(statistics.totalAmount) }}</div>
                <div class="stat-label">累计总成交额</div>
              </div>
            </div>
          </a-col>
          <a-col :xs="12" :sm="12" :md="6">
            <div class="stat-card-large stat-card-blue">
              <div class="stat-icon">
                <a-icon type="file-text" />
              </div>
              <div class="stat-content">
                <div class="stat-value">{{ formatNumber(statistics.totalOrderCount) }}</div>
                <div class="stat-label">累计总单量</div>
              </div>
            </div>
          </a-col>
          <a-col :xs="12" :sm="12" :md="6">
            <div class="stat-card-large stat-card-orange">
              <div class="stat-icon">
                <a-icon type="user" />
              </div>
              <div class="stat-content">
                <div class="stat-value">{{ formatNumber(statistics.totalUserCount) }}</div>
                <div class="stat-label">平台用户总数量</div>
              </div>
            </div>
          </a-col>
          <a-col :xs="12" :sm="12" :md="6">
            <div class="stat-card-large stat-card-purple">
              <div class="stat-icon">
                <a-icon type="team" />
              </div>
              <div class="stat-content">
                <div class="stat-value">{{ formatNumber(statistics.totalMasterCount) }}</div>
                <div class="stat-label">师傅总数量</div>
              </div>
            </div>
          </a-col>
        </a-row>

        <!-- 数据总览 -->
        <div class="section-title">数据总览</div>
        <a-row :gutter="16" class="statistics-row">
          <a-col :xs="24" :sm="8" :md="8">
            <a-card class="stat-card-white">
              <div class="stat-item">
                <span class="stat-item-label">今日订单数</span>
                <span class="stat-item-value">{{ statistics.todayOrderCount || 0 }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-item-label">今日交易额</span>
                <span class="stat-item-value">¥{{ formatAmount(statistics.todayTotalAmount) }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-item-label">今日服务费收入</span>
                <span class="stat-item-value">¥{{ formatAmount(statistics.todayServiceFee) }}</span>
              </div>
            </a-card>
          </a-col>
          <a-col :xs="24" :sm="8" :md="8">
            <a-card class="stat-card-white">
              <div class="stat-item">
                <span class="stat-item-label">正在进行的单量</span>
                <span class="stat-item-value">{{ statistics.processingOrderCount || 0 }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-item-label">订单取消量</span>
                <span class="stat-item-value">{{ statistics.cancelOrderCount || 0 }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-item-label">订单异常量</span>
                <span class="stat-item-value">{{ statistics.abnormalOrderCount || 0 }}</span>
              </div>
            </a-card>
          </a-col>
          <a-col :xs="24" :sm="8" :md="8">
            <a-card class="stat-card-white">
              <div class="stat-item">
                <span class="stat-item-label">本月订单数</span>
                <span class="stat-item-value">{{ statistics.monthOrderCount || 0 }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-item-label">本月交易额</span>
                <span class="stat-item-value">¥{{ formatAmount(statistics.monthTotalAmount) }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-item-label">本月服务费收入</span>
                <span class="stat-item-value">¥{{ formatAmount(statistics.monthServiceFee) }}</span>
              </div>
            </a-card>
          </a-col>
        </a-row>

        <!-- 图表数据 -->
        <div class="section-title">数据趋势</div>
        <a-row :gutter="16" class="statistics-row">
          <a-col :xs="24" :sm="24" :md="24">
            <a-card class="chart-card">
              <div slot="title">近7天数据趋势</div>
              <div ref="combinedChart" class="chart-container-large"></div>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </a-spin>
  </page-header-wrapper>
</template>

<script>
import { timeFix } from '@/utils/util'
import { mapGetters } from 'vuex'
import { PageHeaderWrapper } from '@/components/ProLayout'
import * as echarts from 'echarts'
import { getOverviewStatistics, getChartData as getChartDataApi } from '@/api/dashboard/overview'

export default {
  name: 'Index',
  components: {
    PageHeaderWrapper
  },
  data() {
    return {
      loading: false,
      timeFix: timeFix(),
      roleGroup: {},
      postGroup: {},
      // 统计数据
      statistics: {
        todayTotalAmount: 0, // 本日总交易额
        monthTotalAmount: 0, // 本月总交易额
        todayOrderCount: 0, // 本日订单总量
        monthOrderCount: 0, // 本月订单总量
        todayServiceFee: 0, // 本日平台服务费收入
        monthServiceFee: 0, // 本月平台服务费收入
        totalUserCount: 0, // 平台用户总数量
        totalMasterCount: 0, // 师傅总数量
        totalAmount: 0, // 累计总成交额
        totalOrderCount: 0, // 累计总单量
        cancelOrderCount: 0, // 订单取消量
        abnormalOrderCount: 0, // 订单异常量
        processingOrderCount: 0 // 正在进行的单量
      },
      // 图表实例
      combinedChart: null,
      // 图表数据
      chartData: {
        dates: [],
        userCount: [],
        orderCount: [],
        transactionAmount: [],
        serviceFee: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'avatar',
      'nickname'
    ])
  },
  created() {
    this.getStatistics()
  },
  mounted() {
    // 获取图表数据并初始化图表
    this.getStatistics()
    this.getChartData()
    // 每5分钟刷新一次数据
    this.timer = setInterval(() => {
      this.getStatistics()
      this.getChartData()
    }, 5 * 60 * 1000)
    // 窗口大小改变时重新调整图表
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    window.removeEventListener('resize', this.handleResize)
    // 销毁图表实例
    if (this.combinedChart) {
      this.combinedChart.dispose()
    }
  },
  methods: {
    // 获取统计数据
    getStatistics() {
      this.loading = true
      getOverviewStatistics().then(response => {
        if (response) {
          const data = response.data
          console.log('-----------------------');
          console.log(data);
          console.log('-----------------------');
          this.statistics = {
            todayTotalAmount: data.todayTotalAmount,
            monthTotalAmount: data.monthTotalAmount,
            todayOrderCount: data.todayOrderCount,
            monthOrderCount: data.monthOrderCount,
            todayServiceFee: data.todayServiceFee,
            monthServiceFee: data.monthServiceFee,
            totalUserCount: data.totalUserCount,
            totalMasterCount: data.totalMasterCount,
            totalAmount: data.totalAmount,
            totalOrderCount: data.totalOrderCount,
            cancelOrderCount: data.cancelOrderCount,
            abnormalOrderCount: data.abnormalOrderCount,
            processingOrderCount: data.processingOrderCount
          }
        }
        this.loading = false
      }).catch((error) => {
        console.error('获取统计数据失败:', error)
        this.loading = false
      })
    },
    // 格式化数字（添加千分位）
    formatNumber(value) {
      if (value === null || value === undefined || value === '') {
        return '0'
      }
      const num = Number(value)
      if (isNaN(num)) {
        return '0'
      }
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    // 格式化金额
    formatAmount(value) {
      if (value === null || value === undefined || value === '') {
        return '0.00'
      }
      const num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    // 获取图表数据
    getChartData() {
      getChartDataApi().then(response => {
        if (response) {
          const data = response.data
          let dates = []
          let userCount = []
          let orderCount = []
          let transactionAmount = []
          let serviceFee = []

          try {
            // 后端返回的数组是 JSON 字符串，需要解析
            dates = typeof data.dates === 'string' ? JSON.parse(data.dates || '[]') : (data.dates || [])
            userCount = typeof data.userCount === 'string' ? JSON.parse(data.userCount || '[]') : (data.userCount || [])
            orderCount = typeof data.orderCount === 'string' ? JSON.parse(data.orderCount || '[]') : (data.orderCount || [])
            transactionAmount = typeof data.transactionAmount === 'string' ? JSON.parse(data.transactionAmount || '[]') : (data.transactionAmount || [])
            serviceFee = typeof data.serviceFee === 'string' ? JSON.parse(data.serviceFee || '[]') : (data.serviceFee || [])
          } catch (e) {
            console.error('解析图表数据 JSON 失败:', e, data)
          }

          this.chartData = {
            dates: Array.isArray(dates) ? dates : [],
            userCount: Array.isArray(userCount) ? userCount : [],
            orderCount: Array.isArray(orderCount) ? orderCount : [],
            transactionAmount: Array.isArray(transactionAmount) ? transactionAmount : [],
            serviceFee: Array.isArray(serviceFee) ? serviceFee : []
          }

          // 检查数据是否有效
          if (this.chartData.dates && this.chartData.dates.length > 0) {
            // 延迟初始化，确保 DOM 已渲染
            this.$nextTick(() => {
              setTimeout(() => {
                this.initCharts()
              }, 300)
            })
          }
        }
      }).catch((error) => {
        console.error('获取图表数据失败:', error)
      })
    },
    // 初始化图表
    initCharts() {
      // 检查数据是否有效
      if (!this.chartData || !this.chartData.dates || this.chartData.dates.length === 0) {
        console.warn('图表数据为空，无法初始化图表', this.chartData)
        return
      }

      // 确保 DOM 已渲染
      this.$nextTick(() => {
        if (this.$refs.combinedChart) {
          // 如果已存在实例，先销毁
          if (this.combinedChart) {
            this.combinedChart.dispose()
            this.combinedChart = null
          }
          try {
            this.combinedChart = echarts.init(this.$refs.combinedChart)
            if (this.combinedChart) {
              const option = this.getCombinedChartOption()
              console.log('图表配置:', option)
              this.combinedChart.setOption(option)
              console.log('合并图表初始化成功')
            }
          } catch (error) {
            console.error('初始化合并图表失败:', error)
          }
        } else {
          console.warn('combinedChart ref 不存在')
        }
      })
    },
    // 获取合并图表配置（堆叠面积图）
    getCombinedChartOption() {
      return {
        title: {
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: (params) => {
            let result = params[0].name + '<br/>'
            params.forEach(param => {
              let value = param.value
              if (param.seriesName === '交易额' || param.seriesName === '服务费') {
                value = '¥' + value.toLocaleString()
              } else {
                value = value.toLocaleString()
              }
              result += `${param.marker}${param.seriesName}: ${value}<br/>`
            })
            return result
          }
        },
        legend: {
          data: ['用户量', '订单量', '交易额', '服务费'],
          bottom: 10
        },
        toolbox: {
          feature: {
            saveAsImage: {
              title: '保存为图片'
            }
          },
          right: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          top: '15%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.chartData.dates,
            axisLine: {
              lineStyle: {
                color: '#e8e8e8'
              }
            },
            axisLabel: {
              color: '#666'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '用户量/订单量',
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#e8e8e8'
              }
            },
            axisLabel: {
              color: '#666',
              formatter: '{value}'
            },
            splitLine: {
              lineStyle: {
                color: '#f0f0f0'
              }
            }
          },
          {
            type: 'value',
            name: '交易额/服务费(元)',
            position: 'right',
            axisLine: {
              lineStyle: {
                color: '#e8e8e8'
              }
            },
            axisLabel: {
              color: '#666',
              formatter: (value) => {
                if (value >= 1000) {
                  const k = value / 1000
                  return '¥' + (k % 1 === 0 ? k : k.toFixed(1)) + 'k'
                }
                return '¥' + (Number(value) % 1 === 0 ? value : Number(value).toFixed(2))
              }
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '用户量',
            type: 'line',
            stack: 'Total',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(24, 144, 255, 0.5)' },
                  { offset: 1, color: 'rgba(24, 144, 255, 0.1)' }
                ]
              }
            },
            emphasis: {
              focus: 'series'
            },
            data: this.chartData.userCount,
            itemStyle: {
              color: '#1890ff'
            },
            lineStyle: {
              color: '#1890ff',
              width: 2
            }
          },
          {
            name: '订单量',
            type: 'line',
            stack: 'Total',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(82, 196, 26, 0.5)' },
                  { offset: 1, color: 'rgba(82, 196, 26, 0.1)' }
                ]
              }
            },
            emphasis: {
              focus: 'series'
            },
            data: this.chartData.orderCount,
            itemStyle: {
              color: '#52c41a'
            },
            lineStyle: {
              color: '#52c41a',
              width: 2
            }
          },
          {
            name: '交易额',
            type: 'line',
            yAxisIndex: 1,
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(250, 173, 20, 0.5)' },
                  { offset: 1, color: 'rgba(250, 173, 20, 0.1)' }
                ]
              }
            },
            emphasis: {
              focus: 'series'
            },
            data: this.chartData.transactionAmount,
            itemStyle: {
              color: '#faad14'
            },
            lineStyle: {
              color: '#faad14',
              width: 2
            }
          },
          {
            name: '服务费',
            type: 'line',
            yAxisIndex: 1,
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(114, 46, 209, 0.5)' },
                  { offset: 1, color: 'rgba(114, 46, 209, 0.1)' }
                ]
              }
            },
            emphasis: {
              focus: 'series'
            },
            data: this.chartData.serviceFee,
            itemStyle: {
              color: '#722ed1'
            },
            lineStyle: {
              color: '#722ed1',
              width: 2
            }
          }
        ]
      }
    },
    // 窗口大小改变时重新调整图表
    handleResize() {
      if (this.combinedChart) {
        this.combinedChart.resize()
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./index.less";

  .dashboard-overview {
    margin-top: 24px;
    padding: 0 16px;

    .section-title {
      font-size: 18px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 16px;
      margin-top: 24px;

      &:first-child {
        margin-top: 0;
      }
    }

    .statistics-row {
      margin-bottom: 24px;
    }

    // 大卡片样式（基本信息）
    .stat-card-large {
      height: 140px;
      border-radius: 8px;
      padding: 24px;
      display: flex;
      align-items: center;
      color: #fff;
      transition: all 0.3s;
      cursor: pointer;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
      }

      .stat-icon {
        font-size: 48px;
        margin-right: 20px;
        opacity: 0.9;
      }

      .stat-content {
        flex: 1;

        .stat-value {
          font-size: 32px;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 8px;
        }

        .stat-label {
          font-size: 14px;
          opacity: 0.9;
        }
      }

      &.stat-card-red {
        background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
      }

      &.stat-card-orange {
        background: linear-gradient(135deg, #ffa726 0%, #fb8c00 100%);
      }

      &.stat-card-blue {
        background: linear-gradient(135deg, #42a5f5 0%, #1e88e5 100%);
      }

      &.stat-card-purple {
        background: linear-gradient(135deg, #ab47bc 0%, #8e24aa 100%);
      }
    }

    // 白色卡片样式（今日概括）
    .stat-card-white {
      border-radius: 8px;
      transition: all 0.3s;
      height: 100%;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

      &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
      }

      /deep/ .ant-card-body {
        padding: 20px;
      }

      .stat-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        .stat-item-label {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
        }

        .stat-item-value {
          font-size: 18px;
          font-weight: 600;
          color: #ff6b35;

          &.highlight {
            color: #ff6b35;
            font-size: 24px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .dashboard-overview {
      padding: 0 8px;

      .stat-card-large {
        height: 120px;
        padding: 16px;

        .stat-icon {
          font-size: 36px;
          margin-right: 16px;
        }

        .stat-content {
          .stat-value {
            font-size: 24px;
          }

          .stat-label {
            font-size: 12px;
          }
        }
      }

      .statistics-row {
        margin-bottom: 16px;
      }
    }

    // 图表卡片样式
    .chart-card {
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      transition: all 0.3s;

      &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      }

      /deep/ .ant-card-head {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 20px;

        .ant-card-head-title {
          font-size: 16px;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
        }
      }

      /deep/ .ant-card-body {
        padding: 20px;
      }

      .chart-container {
        width: 100%;
        height: 350px;
        min-height: 350px;
      }

      .chart-container-large {
        width: 100%;
        height: 500px;
        min-height: 500px;
      }
    }
  }
  .chart-container-large {
  width: 100%;
  height: 500px;
  min-height: 500px;
}
</style>
